import { JSONAPIDocument } from "json-api-serializer";
import { API_URL, questionsLoader } from "./QuestionsLoader";
import { PageQuery } from "./typings";
import { stringifyUrl } from "query-string";

export class SkillsApi {
    public static importSkills(data: JSONAPIDocument) {
        return questionsLoader.post({
            baseURL: API_URL,
            url: "/skills/import",
            data: data,
        });
    }

    public static getSKills(query: PageQuery = {}) {
        const url = stringifyUrl({ url: "/skills", query }, { arrayFormat: "comma" });
        return questionsLoader.get({
            baseURL: API_URL,
            url,
        })
    }
}